import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';

import moment from 'moment';
import { SecondsToHHMMSS, examNameAccordingToDB } from '../../../common/constant';
import CBTMockExamsInsructions from '../../Common/CBTInstructions';
import ModalComponent from '../../Common/Modal';
import AppRoutes from '../../config/AppRoutes';
import alertMessage from '../../config/alertMessage';
import CustomButton from '../Button/CustomButton';
import CustomCard from '../CustomCard';
import Header from '../Header';
import LoaderWrapper from '../LoaderWrapper';
import { testListColumns } from '../common';
import {
  deleteUserAttemptedMockExamAPICall,
  getMockDetailsById,
  getUserStatsByMockId,
} from '../services';
import DynamicTable from './DynamicTable';
export default class ViewAttemptedMock extends Component {
  static contextTypes = { router: React.PropTypes.object };

  constructor(props) {
    super(props);
    this.state = {
      userMockList: [],
      actionList: [
        {
          label: 'View',
          action: this.viewTest,
          icon: 'fa fa-eye mark-action-btn-dashboard',
          className: 'mr-md-1',
          style: { color: 'rgb(31, 140, 235)' },
          condition: { status: 'completed' },
        },
        {
          label: 'Resume',
          action: this.resumeTest,
          icon: 'fa fa-play-circle-o mark-action-btn-dashboard',
          condition: { status: 'pending' },
          className: 'mr-md-1',
          style: { color: 'rgb(0, 0, 0)' },
        },
        {
          label: 'delete',
          action: this.deleteUserAttemptedMockExam,
          icon: 'fa fa-trash mark-action-btn-dashboard',
        },
      ],
      additionalParameterForOperation: {
        timer: this.props.params.timer,
        SecondsToHHMMSS,
        moment,
      },

      userSubscriptionDetails: {},
      openPremiumPopup: false,
      isLoading: true,
      showInstructionModal: false,
    };
  }

  viewTest = async (___, item) => {
    const { id, timer } = this.props.params;
    const { id: testId } = item;

    this.context.router.push({
      pathname: AppRoutes.ESG_CBT_FINISH_PAGE.replace(':mockId', id)
        .replace(':timer', timer)
        .replace(':offset', 0)
        .replace(':testId', testId),
    });
  };

  resumeTest = async (event, item) => {
    const { id, timer } = this.props.params;
    const { isNegative, id: testId } = item;
    const lastAnswered = item.lastAnswered ? JSON.parse(item.lastAnswered) : {};
    this.context.router.push({
      pathname: AppRoutes.ESG_CBT_QUESTIONS.replace(':mockId', id)
        .replace(':timer', timer)
        .replace(':timerStart', true)
        .replace(':isNegative', isNegative)
        .replace(':offset', lastAnswered.offset || 0)
        .replace(':testId', testId)
        .replace(':questionId', lastAnswered.question_id || ':questionId'),
    });
  };
  deleteUserAttemptedMockExam = async (event, item) => {
    const result = await deleteUserAttemptedMockExamAPICall({ id: item.id });
    if (result.success) {
      const { id } = this.props.params;
      this.getList(id);
    }
  };

  redirectToInstructionsPage = () => {
    const { id, timer } = this.props.params;

    this.context.router.push({
      pathname: AppRoutes.ESG_CBT_INTRODUCTION.replace(':id', id)
        .replace(':timer', timer)
        .replace(':offset', 0),
    });
  };

  redirectedToMockList = () => {
    this.context.router.push({ pathname: AppRoutes.ESG_CBT });
  };

  componentDidMount = async () => {
    const { id } = this.props.params;
    this.getList(id);
    const response = await getMockDetailsById({ mockId: id });
    if (response.success) {
      this.setState({ title: response.mockData.mock_exam });
    }
    this.setState({ isLoading: false });
  };

  getList = async id => {
    const result = await getUserStatsByMockId({ mockId: id });
    if (result.success) {
      const hasValidSubscription =
        result.userSubscriptionDetails &&
        Object.keys(result.userSubscriptionDetails).length > 0;

      this.setState({
        userMockList: result.userStatsData,
        userSubscriptionDetails: hasValidSubscription
          ? result.userSubscriptionDetails
          : result.hasMockSubscription || null,
      });
    }
  };
  goPremium = async () => {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  };
  toggleAlert = () => {
    this.setState({ openPremiumPopup: !this.state.openPremiumPopup });
  };

  checkSubscription = (cb) => {
    const { userSubscriptionDetails } = this.state;
    const isEmptyObject =
      !userSubscriptionDetails ||
      (typeof userSubscriptionDetails === 'object' &&
        Object.keys(userSubscriptionDetails).length === 0);
    if (isEmptyObject) {
      return this.setState({ openPremiumPopup: true });
    }
    cb();
  };

  render() {
    const {
      title,
      userMockList,
      actionList,
      additionalParameterForOperation,
      isLoading,
      openPremiumPopup,
      showInstructionModal,
    } = this.state;
    return (
      <LoaderWrapper isLoading={isLoading}>
        <div className='animated fadeIn font-16px'>
          <Header title={title}>
            <div className='two-btn-wrapper'>
              <CustomButton
                className='mid-btn'
                onClick={() =>
                  this.checkSubscription(() => this.setState({ showInstructionModal: true }))
                }
              >
                Start
              </CustomButton>
              <CustomButton className='mid-btn' onClick={this.redirectedToMockList}>
                Change Mock
              </CustomButton>
            </div>
          </Header>
          <CustomCard className={'height_70vh esg_custom_card'}>
            <Row>
              <Col>
                <DynamicTable
                  data={userMockList}
                  columns={testListColumns}
                  actionList={actionList}
                  additionalParameterForOperation={additionalParameterForOperation}
                />
              </Col>
            </Row>
          </CustomCard>
          <ModalComponent
            goPremium={this.goPremium}
            toggleAlert={this.toggleAlert}
            alert_status={openPremiumPopup}
            MessageContent={alertMessage.messageContent_ESG}
            exam={examNameAccordingToDB.ESG}
          />
          <CBTMockExamsInsructions
            showInstructionModal={showInstructionModal}
            getQuestions={this.redirectToInstructionsPage}
            handleClose={() => this.setState({ showInstructionModal: false })}
          />
        </div>
      </LoaderWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ESG/CBT/ViewAttemptedMock.jsx